module.exports = __webpack_public_path__ + "assets/mollie-logo.fea3711b.svg";